import React, { useState } from 'react';
import { apiService } from '../../../../services/api';
import { Usuario } from '../../../../types/admin';

interface ModalDeletarReativarUsuarioProps {
  usuario: Usuario;
  action: 'delete' | 'reactivate';
  onClose: () => void;
  onRefresh: () => void;
}

export const ModalDeletarReativarUsuario: React.FC<ModalDeletarReativarUsuarioProps> = ({
  usuario,
  action,
  onClose,
  onRefresh,
}) => {
  const [loading, setLoading] = useState(false);

  const isDeleting = action === 'delete';
  const isReactivating = action === 'reactivate';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isDeleting) {
        await apiService.deleteUsuario(usuario.id);
        alert('Usuário desativado com sucesso!');
      } else {
        await apiService.reativarUsuario({
          id: usuario.id,
          acao: 'reativar'
        });
        alert('Usuário reativado com sucesso!');
      }
      
      onRefresh();
      onClose();
    } catch (error: any) {
      console.error(`Erro ao ${isDeleting ? 'desativar' : 'reativar'} usuário:`, error);
      alert(error.message || `Erro ao ${isDeleting ? 'desativar' : 'reativar'} usuário. Tente novamente.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex={-1}
      id={`modal_${action}_usuario`}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className={`ti ${isDeleting ? 'ti-user-x' : 'ti-user-check'} me-2`}></i>
              {isDeleting ? 'Desativar Usuário' : 'Reativar Usuário'}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={loading}
            />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {isDeleting ? (
                <div className="alert alert-warning" role="alert">
                  <i className="ti ti-alert-triangle me-2"></i>
                  <strong>Atenção!</strong> Esta ação irá desativar o usuário permanentemente.
                </div>
              ) : (
                <div className="alert alert-info" role="alert">
                  <i className="ti ti-info-circle me-2"></i>
                  <strong>Reativação:</strong> O usuário será reativado e poderá acessar o sistema novamente.
                </div>
              )}

              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label">
                      <strong>Usuário:</strong>
                    </label>
                    <div className="card">
                      <div className="card-body py-2">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            {usuario.foto_perfil_url ? (
                              <img
                                src={usuario.foto_perfil_url}
                                alt={usuario.nome}
                                className="rounded-circle"
                                width={40}
                                height={40}
                              />
                            ) : (
                              <div 
                                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                style={{ width: 40, height: 40 }}
                              >
                                {usuario.nome.charAt(0).toUpperCase()}
                              </div>
                            )}
                          </div>
                          <div>
                            <h6 className="mb-0">{usuario.nome} {usuario.sobrenome}</h6>
                            <small className="text-muted">{usuario.email}</small>
                            {usuario.cargo && (
                              <div>
                                <small className="text-muted">{usuario.cargo}</small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-12">
                  <p className="mb-0">
                    {isDeleting ? (
                      <>
                        Tem certeza que deseja <strong className="text-danger">desativar</strong> este usuário?
                        <br />
                        <small className="text-muted">
                          O usuário não conseguirá mais acessar o sistema, mas poderá ser reativado posteriormente.
                        </small>
                      </>
                    ) : (
                      <>
                        Tem certeza que deseja <strong className="text-success">reativar</strong> este usuário?
                        <br />
                        <small className="text-muted">
                          O usuário voltará a ter acesso ao sistema com as mesmas permissões anteriores.
                        </small>
                      </>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className={`btn ${isDeleting ? 'btn-danger' : 'btn-success'}`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {isDeleting ? 'Desativando...' : 'Reativando...'}
                  </>
                ) : (
                  <>
                    <i className={`ti ${isDeleting ? 'ti-user-x' : 'ti-user-check'} me-2`}></i>
                    {isDeleting ? 'Desativar Usuário' : 'Reativar Usuário'}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};